import { useForm } from 'react-hook-form';
import { Link as RouterLink } from 'react-router-dom';
import { useApolloClient } from '@apollo/client';
import { useMutation } from '@apollo/client';
import { REGISTER_USER, REGISTER_FACULTY} from '../../graphql/mutations';
import { useAuthContext } from '../../context/auth';
import { useStateContext } from '../../context/state';
import ErrorMessage from '../../components/ErrorMessage';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { getErrorMsg } from '../../utils/helperFuncs';
import { useState } from 'react';
import RegisterVector from '../../assets/svg/register.svg'
import {useParams} from "react-router-dom";

import {
  TextField,
  Button,
  Typography,
  InputAdornment,
  IconButton,
  Link,
  Grid,
} from '@material-ui/core';
import { useAuthFormStyles } from '../../styles/muiStyles';
import PersonIcon from '@material-ui/icons/Person';
import LockIcon from '@material-ui/icons/Lock';
import EnhancedEncryptionIcon from '@material-ui/icons/EnhancedEncryption';
import PersonAddIcon from '@material-ui/icons/PersonAdd';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';
import VisibilityIcon from '@material-ui/icons/Visibility';
import EmailIcon from '@material-ui/icons/Email';
import jwt_decode from "jwt-decode";

const validationSchema = yup.object({
  email: yup
    .string()
    .required('Required')
    .email(),
  firstName: yup
    .string()
    .required('Required'),
  lastName: yup
    .string()
    .required('Required'),
  password: yup
  .string()
  .required('Please Enter your password')
  .matches(
    /^(?=(?:[^a-z]*[a-z]){2})(?=(?:[^0-9]*[0-9]){2})(?=.*[!-\/:-@\[-`{-~]).{8,}$/i,
    "Must Contain 8 Characters, Atleast One Uppercase, One Lowercase, Two Numbers and one special case Character"
  ),
  confirmPassword: yup
    .string()
    .required('Required')
});

const RegisterForm = () => {
  let { token } = useParams();
  
  const [showPass, setShowPass] = useState(false);
  const [errorMsg, setErrorMsg] = useState(null);
  const [showConfPass, setShowConfPass] = useState(false);
  const classes = useAuthFormStyles();
  const { setUser } = useAuthContext();
  const { notify } = useStateContext();
  var decoded = jwt_decode(token);

  const { register, handleSubmit, reset, errors } = useForm({
    mode: 'onChange',
    resolver: yupResolver(validationSchema),
  });
  const client = useApolloClient();
  const [registerUser, { loading }] = useMutation(REGISTER_USER, {
    onError: (err) => {
      setErrorMsg(getErrorMsg(err));
    },
  });

  const [registerFaculty] = useMutation(REGISTER_FACULTY, {
    onError: (err) => {
      setErrorMsg(getErrorMsg(err));
    },
  });

  const onRegister = ({ email, password, confirmPassword, firstName, lastName }) => {
    let isVerified = true
    if (password !== confirmPassword)
      return setErrorMsg('Both passwords need to match.');
    registerUser({
      variables: { email, password, firstName, lastName, isVerified },
      update: (_, { data }) => {
        setUser(data.register);
        notify(
          `Welcome, ${data.register.fullName}! You've successfully registered.`
        );
        reset();
      },
    });
    client.clearStore();
  };

  const onRegisterFaculty = ({ email, password, confirmPassword, firstName, lastName }) => {
    let isVerified = true
    if (password !== confirmPassword)
      return setErrorMsg('Both passwords need to match.');
    registerFaculty({
      variables: { email, password, firstName, lastName, isVerified },
      update: (_, { data }) => {
        setUser(data.registerFaculty);
        notify(
          `Welcome, ${data.registerFaculty.fullName}! You've successfully registered.`
        );
        reset();
      },
    });
    client.clearStore();
  };
  
return (
    <div className={classes.row}>
      <div className ={classes.column}>
      <img 
            src={RegisterVector} 
            alt="Home Vector" 
            className={classes.homeVector}
          />
      </div>
      <div className ={classes.column}>
        <div className={classes.root}>
          <Typography variant="h4" styles={{color:'#fff'}} >
            Register to <strong className={classes.register}>NEUMeet!</strong>
          </Typography>
          
          <form onSubmit={handleSubmit(decoded.role !== 'faculty' ? onRegister : onRegisterFaculty)} className={classes.form}>
          <Grid container spacing={2}> 
            <Grid item xs={12} sm={6}>
            <TextField
                required
                fullWidth
                autoFocus={true}
                inputRef={register}
                name="firstName"
                type="text"
                label="First Name"
                variant="outlined"
                defaultValue={`${decoded.firstName}`}
                error={'firstName' in errors}
                helperText={'firstName' in errors ? errors.firstName.message : ''}
                InputProps={{
                  readOnly: true,
                  startAdornment: (
                    <InputAdornment position="start">
                      <PersonIcon color="primary" />
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                      required
                      fullWidth                   
                      inputRef={register}
                      name="lastName"
                      type="text"
                      label="Last Name"
                      variant="outlined"
                      error={'lastName' in errors}
                      defaultValue={`${decoded.lastName}`}
                      helperText={'lastName' in errors ? errors.lastName.message : ''}
                      InputProps={{
                        readOnly: true,
                        startAdornment: (
                          <InputAdornment position="start">
                            <PersonIcon color="primary" />
                          </InputAdornment>
                        ),
                      }}
                /> 
            </Grid>
              <Grid item xs={12}>
              <TextField
                  required
                  fullWidth
                  inputRef={register}
                  name="email"
                  type="text"
                  label="Email"
                  variant="outlined"
                  error={'email' in errors}
                  defaultValue={`${decoded.email}`}
                  helperText={'email' in errors ? errors.email.message : ''}
                  InputProps={{
                    readOnly: true,
                    startAdornment: (
                      <InputAdornment position="start">
                        <EmailIcon color="primary" />
                      </InputAdornment>
                    ),
                  }}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                  required
                  fullWidth
                  inputRef={register}
                  name="password"
                  type={showPass ? 'text' : 'password'}
                  label="Password"
                  variant="outlined"
                  error={'password' in errors}
                  helperText={'password' in errors ? errors.password.message : ''}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={() => setShowPass((prevState) => !prevState)}
                          size="small"
                        >
                          {showPass ? (
                            <VisibilityOffIcon color="secondary" />
                          ) : (
                            <VisibilityIcon color="secondary" />
                          )}
                        </IconButton>
                      </InputAdornment>
                    ),
                    startAdornment: (
                      <InputAdornment position="start">
                        <LockIcon color="primary" />
                      </InputAdornment>
                    ),
                  }}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                  required
                  fullWidth
                  inputRef={register}
                  name="confirmPassword"
                  type={showConfPass ? 'text' : 'password'}
                  label="Confirm Password"
                  variant="outlined"
                  error={'confirmPassword' in errors}
                  helperText={
                    'confirmPassword' in errors
                      ? errors.confirmPassword.message
                      : ''
                  }
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={() => setShowConfPass((prevState) => !prevState)}
                          size="small"
                        >
                          {showConfPass ? (
                            <VisibilityOffIcon color="secondary" />
                          ) : (
                            <VisibilityIcon color="secondary" />
                          )}
                        </IconButton>
                      </InputAdornment>
                    ),
                    startAdornment: (
                      <InputAdornment position="start">
                        <EnhancedEncryptionIcon color="primary" />
                      </InputAdornment>
                    ),
                  }}
              />
            </Grid> 
            <Grid item xs={12}>
              <Button
                color="primary"
                variant="contained"
                size="large"
                fullWidth
                startIcon={<PersonAddIcon />}
                type="submit"
                disabled={loading}
                className={classes.submitButton}
              >
                Sign Up
              </Button>
            </Grid>
          </Grid>
          </form>
          <Typography variant="body1" className={classes.footerText}>
            Already have an account?{' '}
            <Link className={classes.link} component={RouterLink} to="/login">
              Log In
            </Link>
          </Typography>
          <ErrorMessage
            errorMsg={errorMsg}
            clearErrorMsg={() => setErrorMsg(null)}
          />
        </div>
      </div>
      
    </div>
  );
};

export default RegisterForm;
